module.exports = {
  PASSWORD_LENGTH_MIN_MESSAGE: "Password must be at least 14 characters long",
  PASSWORD_LENGTH_MAX_MESSAGE: "Password only allows a maximum of 48 characters",
  PASSWORD_NOT_MATCH_MESSAGE: "Passwords do not match",
  PASSWORD_UPDATED_SUCCESFUL_MESSAGE: "Your password has been changed successfully!"
}